import React, { useState } from "react";

import AdminHeader from "../../AdminComponents/AdminHeader/AdminHeader";

import SideBarAdmin from "../../AdminComponents/SideBarAdmin/SideBarAdmin";
// import AddVehicleDrawer from "./AddVehicleDrawer";
// import TableDateAdminVehicle from "./TableDateAdminVehicle";
// import "./VehiclesAdmin.css";
// import './ProfileDriver.css'
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addVehicle } from "../../redux/AdminReducer";
import { useSelector } from "react-redux";
import DriverHeader from "../DiverHeader/DiverHeader";
import SideBarDriver from "../SideBarDriver/SideBarDriver";
import "./DriverVehicle.css";
import DriverVehicleTable from "../DriverVehicleTable/DriverVehicleTable";
const DriverVehicle = () => {
  const [rightHeader, setRightHeader] = useState(false);

  const dispatch = useDispatch();

  const currentUser = useSelector(
    (state) => state?.CustomerReducer?.currentCustomer?.user
  );

  console.log("currentUser", currentUser);

  const navigate = useNavigate();

  const [user, setUser] = useState({
    email: currentUser?.email,
    name: currentUser?.name,
    phone: currentUser?.phone,
    password: "",
    userType: "Customer",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUser({
      ...user,
      [name]: value,
    });
  };

  console.log("user", user);

  const signupClicked = async () => {
    let id = currentUser._id;
    let idData = {
      id: currentUser._id,
    };
    console.log("idClicked", id);
    // const response=await dispatch(editCustomer({user,idData}))

    //   console.log("response",response?.payload?.data?.message)
    // console.log("response",response?.payload.message)

    // Swal.fire(
    //   'Good',
    //   response?.payload.message,
    //   'success'
    // )

    //   if(response?.payload?.success)
    //   {

    //   navigate("/customer/login")
    //   }
  };

  return (
    <>
      {/* <AdminHeader rightHeader={rightHeader} /> */}

      <DriverHeader rightHeader={rightHeader} />

      <div className="topSideVehicles">
        {/* <SideBarAdmin
          setRightHeader={setRightHeader}
          rightHeader={rightHeader}
        /> */}

        <SideBarDriver
          setRightHeader={setRightHeader}
          rightHeader={rightHeader}
        />
        <div
          className="mainDriverVehicle
       "
        >
          <div className="userLoginTxt userLoginTxtProfile">
            You can see detail about your vehicle here..
          </div>

          <DriverVehicleTable/>
        </div>
      </div>
    </>
  );
};

export default DriverVehicle;
